import { Card, Flex, Stack, useTheme, spacing } from '@fti/design-system';

const RESTRICTED_PUBLICATIONS = [
  { name: 'The Wall Street Journal', reason: 'API access via LexisNexis is unavailable for this publication.', badge: 'Restricted' },
  { name: 'Bloomberg', reason: 'API access via LexisNexis is unavailable for this publication. Note: Bloomberg Canada is available.', badge: 'Restricted' },
  { name: 'Fortune Magazine', reason: 'API access via LexisNexis is unavailable for this publication.', badge: 'Restricted' },
  { name: 'Financial Times', reason: 'API access via LexisNexis is unavailable for this publication.', badge: 'Restricted' },
  { name: "Barron's", reason: 'API access via LexisNexis is unavailable for this publication.', badge: 'Restricted' },
  { name: 'Law360', reason: 'Available through LexisNexis, but we frequently (mostly) receive only the first sentence rather than the complete article, which limits the quality of coverage for this publication.', badge: 'Limited' },
];

export function RequestPublicationsPage() {
  const { theme } = useTheme();

  return (
    <div style={{ padding: spacing.lg, maxWidth: 720 }}>
      <Stack gap="lg">
        <div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 600, color: theme.colors.text.primary, margin: 0 }}>
            Request Publications
          </h1>
          <p style={{ fontSize: '0.9rem', color: theme.colors.text.secondary, margin: `${spacing.sm} 0 0`, lineHeight: 1.6 }}>
            To request additional publications not already available in{' '}
            <strong>Explore Publications</strong>, please email{' '}
            <a
              href="mailto:marycatherine.sullivan@fticonsulting.com"
              style={{ color: theme.colors.primary[500], textDecoration: 'none', fontWeight: 500 }}
            >
              marycatherine.sullivan@fticonsulting.com
            </a>. The team is always working to expand available coverage.
          </p>
        </div>

        <Card variant="outlined">
          <Card.Header
            title="Restricted & Limited Publications"
            subtitle="The following publications are unavailable or have limited coverage due to licensing restrictions and API access."
          />
          <Card.Body>
            <Stack gap="xs">
              {RESTRICTED_PUBLICATIONS.map((pub) => (
                <Flex
                  key={pub.name}
                  justify="between"
                  align="center"
                  style={{
                    padding: `${spacing.sm} 0`,
                    borderBottom: `1px solid ${theme.colors.border.default}`,
                  }}
                >
                  <div>
                    <span style={{ fontSize: '0.9rem', fontWeight: 500, color: theme.colors.text.primary }}>
                      {pub.name}
                    </span>
                    <p style={{ fontSize: '0.8rem', color: theme.colors.text.secondary, margin: `2px 0 0` }}>
                      {pub.reason}
                    </p>
                  </div>
                  <span
                    style={{
                      display: 'inline-block',
                      padding: `2px ${spacing.xs}`,
                      fontSize: '0.7rem',
                      fontWeight: 600,
                      borderRadius: '4px',
                      backgroundColor:
                        pub.badge === 'Limited'
                          ? theme.colors.semantic.warning.default
                          : theme.colors.neutral[200],
                      color:
                        pub.badge === 'Limited'
                          ? theme.colors.text.inverse
                          : theme.colors.text.secondary,
                      textTransform: 'uppercase',
                      whiteSpace: 'nowrap',
                      marginLeft: spacing.md,
                      flexShrink: 0,
                    }}
                  >
                    {pub.badge}
                  </span>
                </Flex>
              ))}
            </Stack>
          </Card.Body>
        </Card>

        <p style={{ fontSize: '0.8rem', color: theme.colors.text.secondary, margin: 0, fontStyle: 'italic' }}>
          This list is periodically updated as licensing and access agreements change.
        </p>
      </Stack>
    </div>
  );
}
